import axios from 'axios';
import { isRecord } from '../../../@interfaces/site-analytics/validation';
// 通信障害や認証エラーを「削除済み」と誤表示せず、APIが明示したサイト不在だけを扱う。
export const isSiteUnavailableError = (error) => {
    var _a;
    return axios.isAxiosError(error) &&
        ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 404 &&
        isRecord(error.response.data) &&
        ['SITE_NOT_FOUND', 'SITE_UNAVAILABLE'].includes(String(error.response.data.code));
};
export const isExpectedSiteUnavailableReadError = (error) => {
    var _a, _b;
    return isSiteUnavailableError(error) &&
        axios.isAxiosError(error) &&
        ((_b = (_a = error.config) === null || _a === void 0 ? void 0 : _a.method) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === 'get';
};
